import React, { useMemo, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { usePosts } from '../context/PostsContext';
import { findRelatedPosts, scrollToTop } from '../utils';
import { trackPageView } from '../utils/analytics';
import { ENTITY } from '../utils/constants';
import Header from '../components/Header';
import PostDetail from '../components/PostDetail';
import Footer from '../components/Footer';

const PostDetailPage = () => {
  const { slug: id } = useParams();
  const navigate = useNavigate();
  const { postsData } = usePosts();

  const post = useMemo(() => {
    if (isNaN(id)) {
      const normalizedId = id.toLowerCase();
      return postsData.find(
        (p) => typeof p.slug === 'string' && p.slug.toLowerCase() === normalizedId
      );
    }
    const postId = parseInt(id);
    return postsData.find((p) => p.id === postId);
  }, [id, postsData]);

  useEffect(() => {
    if (post) {
      trackPageView(`/${ENTITY.routes.detailPath}/${id}/`, post.name);
    }
  }, [post, id]);

  const relatedPosts = useMemo(
    () => findRelatedPosts(postsData, post),
    [post, postsData]
  );

  const handleSelectPost = useCallback(
    (selectedPost) => {
      navigate(`/${ENTITY.routes.detailPath}/${selectedPost.slug}/`);
      scrollToTop();
    },
    [navigate]
  );

  const handleBackToList = useCallback(() => {
    navigate('/');
    scrollToTop();
  }, [navigate]);

  const handleSearchSlug = useCallback(() => {
    const searchQuery = id.replace(/[-_]/g, ' ');
    navigate(`/?search=${encodeURIComponent(searchQuery)}`);
    scrollToTop();
  }, [navigate, id]);

  const handleTagClick = useCallback(
    (tag) => {
      navigate(`/?tag=${encodeURIComponent(tag)}`);
      scrollToTop();
    },
    [navigate]
  );

  if (!post) {
    const searchQuery = id.replace(/[-_]/g, ' ');
    return (
      <div className="app">
        <Header />
        <main id="main-content" className="detail-content">
          <div className="not-found">
            <h2>{ENTITY.labels.notFound}</h2>
            <p>{ENTITY.labels.notFoundMessage(searchQuery)}</p>
            <button className="search-btn" onClick={handleSearchSlug}>
              {ENTITY.labels.searchButton}
            </button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <PostDetail
      post={post}
      onBack={handleBackToList}
      relatedPosts={relatedPosts}
      onSelectPost={handleSelectPost}
      onTagClick={handleTagClick}
    />
  );
};

export default PostDetailPage;
